import moment from "moment"

export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        let dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map(key => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}


export const replaceUrlParams = (url: string, params: any) => {
    Object.keys(params).map((param) => {
        url = url.replace(`:${param}`, params[param])
    })
    return url
}


export const showDate = (dbDate: any, dateFormat: any = 'DD MMM, YYYY') => {
    return (dbDate !== '') ? moment(dbDate).format(dateFormat) : "";
}

export const proposalStatus = (status: any) => {
    if (status == 0) {
        return "Pending"
    } else if (status == 1) {
        return "Submitted"
    } else if (status == 2) {
        return "Proposal Ready"
    } else if (status == 3) {
        return "Proposal Approved"
    } else if (status == 4) {
        return "Proposal Rejected"
    } else if (status == 5) {
        return "Completed"
    } else {
        return "Pending"
    }
}
export const proposalStatusButton = (status: any) => {
    if (status == 0) {
        return "pending"
    } else if (status == 1) {
        return "submitted"
    } else if (status == 2) {
        return "proposal_ready"
    } else if (status == 3) {
        return "proposal_approved"
    } else if (status == 4) {
        return "proposal_rejected"
    } else if (status == 5) {
        return "completed"
    } else {
        return "pending"
    }
}
export const dedupeById = (items: any[]) => {
    const seen = new Set();
    return items.filter(item => {
        if (seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
    });
}

export const countryFlag = (countryCode: any) => {
    // if (countryCode) {
    //     return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
    // } else {
    //     return `https://flagcdn.com/w320/xx.png`
    // }
    if (countryCode == 'USA') {
        return "🇺🇸"
    } else if (countryCode == 'IN') {
        return "🇮🇳"
    } else if (countryCode == 'UK') {
        return "🇬🇧"
    } else if (countryCode == 'CA') {
        return "🇨🇦"
    } else if (countryCode == 'AU') {
        return "🇦🇺"
    } else if (countryCode == 'FR') {
        return "🇫🇷"
    } else if (countryCode == 'DE') {
        return "🇩🇪"
    } else if (countryCode == 'JP') {
        return "🇯🇵"
    } else if (countryCode == 'BR') {
        return "🇧🇷"
    } else if (countryCode == 'ZA') {
        return "🇿🇦"
    } else if (countryCode == 'IT') {
        return "🇮🇹"
    } else if (countryCode == 'ES') {
        return "🇪🇸"
    } else if (countryCode == 'RU') {
        return "🇷🇺"
    } else if (countryCode == 'MX') {
        return "🇲🇽"
    } else if (countryCode == 'KR') {
        return "🇰🇷"
    } else if (countryCode == 'NL') {
        return "🇳🇱"
    } else if (countryCode == 'SE') {
        return "🇸🇪"
    } else if (countryCode == 'NO') {
        return "🇳🇴"
    } else if (countryCode == 'FI') {
        return "🇫🇮"
    } else if (countryCode == 'DK') {
        return "🇩🇰"
    } else if (countryCode == 'PL') {
        return "🇵🇱"
    } else if (countryCode == 'PT') {
        return "🇵🇹"
    } else if (countryCode == 'TR') {
        return "🇹🇷"
    } else if (countryCode == 'AR') {
        return "🇦🇷"
    } else if (countryCode == 'CL') {
        return "🇨🇱"
    } else if (countryCode == 'CO') {
        return "🇨🇴"
    } else if (countryCode == 'PE') {
        return "🇵🇪"
    } else if (countryCode == 'VE') {
        return "🇻🇪"
    } else if (countryCode == 'PH') {
        return "🇵🇭"
    } else if (countryCode == 'TH') {
        return "🇹🇭"
    } else if (countryCode == 'SG') {
        return "🇸🇬"
    } else if (countryCode == 'MY') {
        return "🇲🇾"
    } else if (countryCode == 'VN') {
        return "🇻🇳"
    } else if (countryCode == 'ID') {
        return "🇮🇩"
    } else if (countryCode == 'HK') {
        return "🇭🇰"
    } else {
        return ""
    }
}